import HomeBody from '../home/homeBody';
import HomeBottom from '../home/homeBottom';
import HomeHero from '../home/homeHero';
import HomePlug from '../home/homePlug';

export default function HomeView() {
  return (
    <>
      <HomeHero />

      <HomeBody />

      <HomeBottom />

      <HomePlug />
    </>
  );
}
